import React, { useState } from 'react';

const ChannelCard = ({ channel, isPlaying, onPlay }) => {
  const [imgError, setImgError] = useState(false);
  const isWorldCup = channel.cat === 'worldcup';

  const formatNumber = (n) => {
    if (!n) return '0';
    if (n >= 1000000) return (n / 1000000).toFixed(1) + 'M';
    if (n >= 1000) return (n / 1000).toFixed(1) + 'K';
    return n.toString();
  };

  return (
    <div
      onClick={() => onPlay(channel.id)}
      style={{
        background: 'var(--card)',
        border: `1px solid ${isPlaying ? 'var(--accent2)' : isWorldCup ? 'var(--worldcup-glow)' : 'var(--border)'}`,
        borderRadius: '10px',
        overflow: 'hidden',
        cursor: 'pointer',
        transition: '0.2s',
        position: 'relative',
        boxShadow: isWorldCup ? '0 0 20px rgba(245,200,66,0.15)' : 'none',
        touchAction: 'manipulation',
        WebkitTapHighlightColor: 'transparent'
      }}
      className="channel-card"
    >
      <div style={{
        width: '100%',
        aspectRatio: '16/9',
        background: 'linear-gradient(135deg,#1a1a2e,#16213e)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '32px',
        position: 'relative',
        overflow: 'hidden',
        minHeight: '100px'
      }}>
        {channel.icon && (channel.icon.startsWith('http') || channel.icon.startsWith('data:image')) && !imgError ? (
          <img
            src={channel.icon}
            alt={channel.name}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              position: 'absolute',
              top: 0,
              left: 0
            }}
            onError={() => setImgError(true)}
            loading="lazy"
          />
        ) : (
          <span style={{
            fontSize: '36px',
            zIndex: 1,
            position: 'relative'
          }}>{channel.icon || '📺'}</span>
        )}
        
        {channel.status === 'live' ? (
          <span style={{
            position: 'absolute',
            top: '6px',
            left: '6px',
            background: 'var(--live)',
            color: '#fff',
            fontSize: '8px',
            fontWeight: 700,
            padding: '2px 5px',
            borderRadius: '3px',
            letterSpacing: '0.5px',
            zIndex: 1
          }}>LIVE</span>
        ) : (
          <span style={{
            position: 'absolute',
            top: '6px',
            left: '6px',
            background: '#555',
            color: '#ccc',
            fontSize: '8px',
            fontWeight: 700,
            padding: '2px 5px',
            borderRadius: '3px',
            letterSpacing: '0.5px',
            zIndex: 1
          }}>OFF</span>
        )}
        
        {isWorldCup && (
          <span style={{
            position: 'absolute',
            top: '6px',
            right: '6px',
            background: 'var(--worldcup-glow)',
            color: '#000',
            fontSize: '7px',
            fontWeight: 800,
            padding: '2px 5px',
            borderRadius: '3px',
            letterSpacing: '0.3px',
            zIndex: 1
          }}>🏆 WC</span>
        )}
        
        {channel.status === 'live' && (
          <span style={{
            position: 'absolute',
            bottom: '6px',
            right: '6px',
            background: 'rgba(0,0,0,.7)',
            color: 'rgba(255,255,255,.8)',
            fontSize: '9px',
            padding: '2px 6px',
            borderRadius: '3px',
            zIndex: 1
          }}>👁 {formatNumber(channel.viewers)}</span>
        )}
      </div>
      
      <div style={{ padding: '8px 10px' }}>
        <div style={{
          fontSize: '12px',
          fontWeight: 600,
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          display: 'flex',
          alignItems: 'center',
          gap: '4px'
        }}>
          {isWorldCup && '🏆 '}
          {channel.name}
        </div>
        <div style={{
          fontSize: '10px',
          color: 'var(--muted)',
          marginTop: '2px',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis'
        }}>{channel.desc || channel.cat}</div>
      </div>
    </div>
  );
};

export default ChannelCard;